import { Directive, HostListener } from '@angular/core';

import { statusCode } from 'src/app/utility/constant/config';

@Directive({
    selector: '.content-block',
    standalone: false,
})
export class ContentBlockScrollDirective {
    private readonly scrollPositionStartingDisplay: number =
        statusCode.internalServerError;
    private scrollUpButtonFlag = false;
    private stickTheadFlag = false;
    private readonly theadScrollPosition: number = 80;

    @HostListener('scroll') checkScroll() {
        const contentBlock =
            document.getElementsByClassName('content-block')[0];
        const scrollerButton = document.getElementById('scroller-go-up');
        const head = document.getElementsByClassName('heatmap-header')[0];

        if (
            !this.stickTheadFlag &&
            head.getBoundingClientRect().top < this.theadScrollPosition
        ) {
            this.stickThead('stick');
            this.stickTheadFlag = true;
        }

        if (
            this.stickTheadFlag &&
            head.getBoundingClientRect().top >= this.theadScrollPosition
        ) {
            this.stickThead('unstick');
            this.stickTheadFlag = false;
        }

        if (scrollerButton) {
            if (
                !this.scrollUpButtonFlag &&
                contentBlock.scrollTop >= this.scrollPositionStartingDisplay
            ) {
                scrollerButton.style.display = 'block';
                this.scrollUpButtonFlag = true;
            } else if (
                this.scrollUpButtonFlag &&
                contentBlock.scrollTop < this.scrollPositionStartingDisplay
            ) {
                scrollerButton.style.display = 'none';
                this.scrollUpButtonFlag = false;
            }
        }
    }

    stickThead(action: string) {
        const legendWrapper =
            document.getElementsByClassName('legend-wrapper')[0];
        const heatmapThead =
            document.getElementsByClassName('heatmap-table')[0];
        const depricatedModel = document.getElementsByClassName(
            'heatmap-banner-hidden'
        )[0];
        if (heatmapThead) {
            if (action === 'stick') {
                legendWrapper.classList.add('sticky-legend-wrapper');
                heatmapThead.classList.add('sticky-table-header');
                if (depricatedModel)
                    depricatedModel.classList.add('heatmap-banner-show');
            } else if (action === 'unstick') {
                legendWrapper.classList.remove('sticky-legend-wrapper');
                heatmapThead.classList.remove('sticky-table-header');
                if (depricatedModel)
                    depricatedModel.classList.remove('heatmap-banner-show');
            }
        }
    }
}
